// extracted by mini-css-extract-plugin
module.exports = {"related-links":"related-links-component-module__okLWwW__related-links"};